export default __webpack_public_path__ + "static/media/increaseEngagement.f9641b35.svg";